import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/css/app.min.css';
import './assets/css/logbook.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css'
console.disableYellowBox = true;
ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js